var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#404347",
  d: "M14.242 10.662 22.98.5h-2.07l-7.587 8.824L7.263.5H.273l9.164 13.343L.273 24.5h2.071l8.012-9.318 6.4 9.318h6.99zm-2.836 3.299-.928-1.329L3.09 2.06h3.18l5.963 8.532.928 1.329 7.75 11.09h-3.18z"
})));
export default SvgXTwitter;